export enum AutomationActionIds {
    return = "return",
    damage = "damage",
}
